import MatriculasIndexPage from "@/Pages/Matriculas/index.vue";
import NewEditMatriculaPage from "@/Pages/Matriculas/NewEditMatriculaPage.vue";
import DesempenhoNotaAluno from "@/Pages/Matriculas/DesempenhoNotaAluno.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/matriculas/",
    name: "matriculas",
    component: MatriculasIndexPage,
    beforeEnter: checkPermission(["matriculas.matricular", "matriculas.*"]),
  },
  {
    path: "/matriculas/create",
    name: "matriculas.create",
    component: NewEditMatriculaPage,
    props: { editing: false },
    beforeEnter: checkPermission(["matriculas.matricular", "matriculas.*"]),
  },
  {
    path: "/matriculas/edit/:matricula_id",
    name: "matriculas.edit",
    component: NewEditMatriculaPage,
    props: { editing: true },
    beforeEnter: checkPermission(["matriculas.matricular", "matriculas.*"]),
  },
  {
    path: "/matriculas/desempenho-de-notas-do-aluno/matricula/:matricula_id",
    name: "matriculas.desempenhoNota",
    component: DesempenhoNotaAluno,
    props: { editing: true },
  },
];
